import { Controller } from "@hotwired/stimulus"

// Polls import job show page while status is pending/processing so completion
// is visible even if Action Cable broadcast is missed.
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 2000 }
  }

  connect() {
    this.timer = setInterval(() => this.refresh(), this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  refresh() {
    fetch(this.urlValue, {
      headers: {
        Accept: "text/html",
        "X-Requested-With": "XMLHttpRequest"
      },
      credentials: "same-origin"
    })
      .then((response) => {
        if (!response.ok) return null
        return response.text()
      })
      .then((html) => {
        if (!html) return
        const doc = new DOMParser().parseFromString(html, "text/html")
        const next = doc.getElementById(this.element.id)
        if (!next) return

        this.element.innerHTML = next.innerHTML

        const badge = this.element.querySelector(".badge")
        const text = badge?.textContent?.trim()?.toLowerCase() || ""
        if (text === "completed" || text === "failed") {
          clearInterval(this.timer)
          this.timer = null
          // Reload once so flash/chrome reflects final state and polling stops cleanly
          window.location.reload()
        }
      })
      .catch(() => {})
  }
}
